<template>
  <div class="card-search">
    <svg-loader src="/static/images/exams.svg" />
    <div class="wrapper">
      <h2>{{ title }}</h2>
      <h3>{{ subtitle }}</h3>
    </div>
    <fast-search />
  </div>
</template>

<script>
import Card from '../Card'
import FastSearch from '../Widgets/FastSearch'
import Infotip from '@/components/common/infotip/Infotip'

import { mapGetters } from 'vuex'
import SvgLoader from '../../common/SvgLoader.vue'

export default {
  name: 'CardSearch',
  components: {
    card: Card,
    infotip: Infotip,
    'fast-search': FastSearch,
    'svg-loader': SvgLoader
  },
  data: () => ({
    title: 'Minha Rotina - Busca',
    subtitle: 'Busque pelos seus exames e amostras',
  }),
  computed: {
    ...mapGetters(['toggle'])
  }
}
</script>

<style lang="scss" scoped>
.card-search {
  font-family: 'Exo 2', sans-serif !important;

  margin-bottom: 16px;
  background-color: #FFFFFF;
  border-radius: 6px;
  padding: 12px 16px;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: normal;
  padding: 0 24px 0 12px;
  margin: 0;

  h2 {
    font-size: 18px;
  }

  h3 {
    font-size: 12px;
    font-weight: normal;
  }

  h2,
  h3 {
    color: #6D6D6D
  }
}
</style>
